var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSideGreenDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.851,
    height: 9.244,
    viewBox: "0 0 10.851 9.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58066",
    "data-name": "Group 58066",
    transform: "translate(0.207 0.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M9.155,6.009l3.67,3.654a.792.792,0,0,1,0,1.119l-3.67,3.653a.789.789,0,0,1-1.114-1.118l3.108-3.1L8.041,7.128A.789.789,0,0,1,9.155,6.009Z",
    transform: "translate(-7.809 -5.779)",
    fill: "#00d95a",
    stroke: "#00d95a",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-2",
    "data-name": "Combined-Shape",
    d: "M9.155,6.009l3.67,3.654a.792.792,0,0,1,0,1.119l-3.67,3.653a.789.789,0,0,1-1.114-1.118l3.108-3.1L8.041,7.128A.789.789,0,0,1,9.155,6.009Z",
    transform: "translate(-2.562 -5.779)",
    fill: "#00d95a",
    stroke: "#00d95a",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSideGreenDoubleArrow);
export default __webpack_public_path__ + "static/media/rightSideGreenDoubleArrow.0c72625cb6d09d1827e4d0cdc55d2c7d.svg";
export { ForwardRef as ReactComponent };